<template>
  <div class="components" :style="componentsWrapStyle">
    <div ref="scrollWrap" class="components-scroll">
      <el-tree
        ref="compTree"
        :data="layerTreeDatas"
        node-key="id"
        default-expand-all
        :highlight-current="true"
        :expand-on-click-node="false"
        :current-node-key="treeCurrentKey === 'Back' ? null : treeCurrentKey"
        @node-click="onNodeClick"
        draggable
        :allow-drop="allowDrop"
        :allow-drag="allowDrag"
        @node-drag-end="handleDragEnd"
      >
        <span class="comp-tree-node" :style="treeNodeStyle(data)" :class="{ 'comp-tree-error': isError(data.id), 'comp-tree-multi-selected': isTreeNodeMultiSelected(data.id) }" slot-scope="{ node, data }">
          <div class="comp-left-label">
            <i v-if="componentIconConfig[data.component]" :class="['iconfont', componentIconConfig[data.component].indexOf('el') !== -1 ? componentIconConfig[data.component] : `icon-${componentIconConfig[data.component]}`]" />
            <span
              :title="data.component === 'v-button' ? data.propValue : data.label"
            >{{ data.component === "v-button" ? data.propValue : $tt(data.label) }}</span>
            <i
              v-if="hasBindMark(data)"
              class="layer-bind-dot"
              :title="$tt('已配置指令或事件')"
            />
            <el-tag v-if="data.compType === ECOLOGICAL_SIGN || node.level > 1" size="mini" type="danger" effect="dark">{{ $tt("生态控件") }}</el-tag>
            <el-tag v-else size="mini" type="success" effect="dark">{{ $tt("基本控件") }}</el-tag>
          </div>
          <span class="tree-right-btn">
            <el-button
              type="text"
              size="mini"
              v-if="data.isLock"
              @click.stop="unlock(data)">
              <i class="el-icon-lock" />
            </el-button>
            <el-button
              type="text"
              size="mini"
              v-else
              @click.stop="lock(data)">
              <i class="el-icon-unlock" />
            </el-button>
            <el-popconfirm
              :title="data.compType === ECOLOGICAL_SIGN ? $tt('删除当前按钮会清空组内所有按钮，确定要删除吗？') : $tt('确定要删除吗？')"
              @confirm="deleteC(data)"
            >
              <el-button
                slot="reference"
                type="text"
                size="mini"
              >
                <i class="el-icon-delete" />
              </el-button>
            </el-popconfirm>
          </span>
        </span>
      </el-tree>
    </div>
    <div
      v-if="backTreeData"
      class="components-back-row"
      :class="{ 'is-current': isBackCurrent }"
      @click="onNodeClick(backTreeData)"
    >
      <span class="comp-tree-node" :style="treeNodeStyle(backTreeData)" :class="{ 'comp-tree-error': isError(backTreeData.id) }">
        <div class="comp-left-label">
          <i v-if="componentIconConfig[backTreeData.component]" :class="['iconfont', componentIconConfig[backTreeData.component].indexOf('el') !== -1 ? componentIconConfig[backTreeData.component] : `icon-${componentIconConfig[backTreeData.component]}`]" />
          <span :title="$tt(backTreeData.label)">{{ $tt(backTreeData.label) }}</span>
        </div>
      </span>
    </div>

    <!-- <div
      v-for="c in componentData"
      :key="c.id"
      :class="['component', activeCId == c.id && 'activeC']"
      @click="setActive(c)"
    >
      <div class="type" :style="{background: isError(c.id) ? 'red': '#d2d2d2' }">
        <i :class="['iconfont', `icon-${componentIconConfig[c.component]}`]" />
        <div class="text">{{ c.label }}</div>
      </div>
      <div class="operations">
        <span v-if="c.id != 'Back'">
          <i class="el-icon-delete" @click.stop="deleteC(c)" />
          <i class="el-icon-lock" v-if="c.isLock" @click.stop="unlock" />
          <i class="el-icon-unlock" v-else @click.stop="lock" />
        </span>
      </div>
    </div> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import eventBus from "@/utils/eventBus";
import { ECOLOGICAL_SIGN, ECOLOGICAL_CHILDREN_SIGN } from '@/constants/editor';

import { componentIconConfig } from "@/custom-component/component-list.js";
import { hasCanvasBind } from "@/utils/canvasBindSummary";
export default {
  props: ['maxH'],
  data() {
    return {
      componentIconConfig,
      activeCId: "",
      ECOLOGICAL_SIGN,
      ECOLOGICAL_CHILDREN_SIGN
    };
  },
  computed: {
    ...mapState(["componentData", "curComponent", "curErrorMap", "selectedCurrentPage", "areaData"]),
    hasBindMark() {
      return (data) => hasCanvasBind(data);
    },
    isError() {
      return (id) => {
        const info = this.curErrorMap[id];
        if (info) {
          let hasError = false;
          for (let key in info) {
            if (typeof(info[key]) === 'string' && info[key]) {
              hasError = true;
              break;
            } else if (typeof(info[key]) === 'object') {
              // 状态灯的-被动监听，多个设备时，需要再次嵌套
              for (let deviceAttrId in info[key]) {
                if (info[key][deviceAttrId]) {
                  hasError = true;
                  break;
                }
              }
            }
          }
          return hasError;
        }
        return false;
      };
    },
    componentsWrapStyle() {
      if (!this.maxH) {
        return {};
      }
      return {
        maxHeight: `${this.maxH}px`,
        height: `${this.maxH}px`,
      };
    },
    backTreeData() {
      if (!this.componentData || this.componentData.length === 0) {
        return null;
      }
      const backItem = this.componentData.find((item) => item.id === "Back");
      return backItem ? this.formatTreeItem(backItem) : null;
    },
    layerTreeDatas() {
      if (!this.componentData || this.componentData.length === 0) {
        return [];
      }
      const otherItems = this.componentData.filter((item) => item.id !== "Back");
      // 按 zIndex 降序：画布最上层在列表最上方
      return [...otherItems]
        .sort((a, b) => {
          const diff = this.getLayerSortKey(b) - this.getLayerSortKey(a);
          if (diff !== 0) {
            return diff;
          }
          const ai = this.componentData.findIndex((c) => c && c.id === a.id);
          const bi = this.componentData.findIndex((c) => c && c.id === b.id);
          return bi - ai;
        })
        .map((item) => this.formatTreeItem(item));
    },
    isBackCurrent() {
      return !this.isMultiSelect && this.treeCurrentKey === "Back";
    },
    treeCurrentKey() {
      return (this.curComponent && this.curComponent.id) || this.activeCId || null;
    },
    treeOrderSign() {
      return (this.componentData || [])
        .map((item) => {
          if (!item || !item.id) {
            return "";
          }
          const z = item.style && item.style.zIndex;
          return `${item.id}:${z != null ? z : ""}`;
        })
        .join(",");
    },
    multiSelectedIds() {
      const list = (this.areaData && this.areaData.components) || [];
      return list.map((c) => c && c.id).filter(Boolean);
    },
    isMultiSelect() {
      return this.multiSelectedIds.length > 1;
    },
  },
  mounted() {
    //第一个页面加载时,初始化第一个选中组件
    this.setActive(this.componentData[0], 0);
  },
  watch: {
    curComponent() {
      if (!this.isMultiSelect) {
        this.activeCId = this.treeCurrentKey;
      }
      this.syncTreeHighlight(true);
    },
    areaData: {
      deep: true,
      handler() {
        this.syncTreeHighlight(true);
      },
    },
    treeOrderSign() {
      // 上移/下移会改树顺序但不改 curComponent 引用，需重新高亮
      this.syncTreeHighlight(true);
    },
    //在切换页面后,默认选中第一个组件
    selectedCurrentPage() {
      this.setActive(this.componentData[0], 0);
    },
  },
  methods: {
    formatTreeItem(item) {
      if (item.compType === ECOLOGICAL_SIGN) {
        const ecologyItem = Object.assign({}, item, { children: [] });
        item.propValue &&
          item.propValue.forEach((childItem) => {
            ecologyItem.children.push(childItem);
          });
        return ecologyItem;
      }
      return item;
    },
    getLayerSortKey(item) {
      if (!item) {
        return 0;
      }
      const z = item.style && item.style.zIndex;
      if (z != null && z !== "") {
        const num = Number(z);
        if (!Number.isNaN(num)) {
          return num;
        }
      }
      const idx = this.componentData.findIndex((c) => c && c.id === item.id);
      return idx >= 0 ? idx + 1 : 0;
    },
    isTreeNodeMultiSelected(id) {
      if (!this.isMultiSelect) {
        return false;
      }
      const sid = String(id);
      return this.multiSelectedIds.some((mid) => String(mid) === sid);
    },
    treeNodeStyle(data) {
      if (this.isError(data.id)) {
        return { background: "#fda6a6" };
      }
      if (this.isTreeNodeMultiSelected(data.id)) {
        return { background: "#1c92ff", color: "#fff", fontWeight: 600 };
      }
      return {};
    },
    clearMultiHighlight() {
      const nodes = this.$el.querySelectorAll(
        ".el-tree-node__content.is-multi-current"
      );
      nodes.forEach((n) => n.classList.remove("is-multi-current"));
    },
    applyMultiHighlight() {
      const tree = this.$refs.compTree;
      if (!tree || !tree.getNode) {
        return;
      }
      this.multiSelectedIds.forEach((id) => {
        const node = tree.getNode(id);
        const content =
          node &&
          node.$el &&
          node.$el.querySelector(".el-tree-node__content");
        if (content) {
          content.classList.add("is-multi-current");
        }
      });
    },
    allowDrop(draggingNode, dropNode, type) {
      return type !== "inner";
    },
    allowDrag(draggingNode) {
      return draggingNode.data.id !== 'Back' && draggingNode.level === 1;
    },
    handleDragEnd(draggingNode, dropNode, dropType) {
      if (!dropType || dropType === "none" || !dropNode || !draggingNode) {
        return;
      }
      const tree = this.$refs.compTree;
      if (!tree || !tree.store || !tree.store.root) {
        return;
      }
      const topNodes = tree.store.root.childNodes || [];
      const orderedIds = topNodes
        .map((n) => n && n.data && n.data.id)
        .filter((id) => id != null);
      if (!orderedIds.length) {
        return;
      }
      const byId = {};
      this.componentData.forEach((item) => {
        if (item && item.id != null) {
          byId[item.id] = item;
        }
      });
      const next = [];
      const used = {};
      // 列表自上而下 = 画布由前到后；写入 componentData 时背景在前、层级递增
      if (byId.Back) {
        next.push(JSON.parse(JSON.stringify(byId.Back)));
        used.Back = true;
      }
      orderedIds
        .reverse()
        .forEach((id) => {
          if (used[id] || !byId[id]) {
            return;
          }
          next.push(JSON.parse(JSON.stringify(byId[id])));
          used[id] = true;
        });
      this.componentData.forEach((item) => {
        if (item && item.id != null && !used[item.id]) {
          next.push(JSON.parse(JSON.stringify(item)));
          used[item.id] = true;
        }
      });
      next.forEach((item, ind) => {
        if (item.style) {
          item.style.zIndex = ind + 1;
        }
      });
      this.$store.commit("setComponentData", next);
      this.$store.commit("recordSnapshot");
      const curId = this.curComponent && this.curComponent.id;
      if (curId) {
        const ind = next.findIndex((i) => i.id === curId);
        if (ind !== -1) {
          this.$store.commit("setCurComponent", {
            component: next[ind],
            index: ind,
          });
        }
      }
    },
    onNodeClick(data, node, a, b) {
      if (!data) {
        return;
      }
      const evt =
        (b && typeof b.shiftKey === "boolean" && b) ||
        (a && typeof a.shiftKey === "boolean" && a) ||
        window.event;
      const dataInd = this.componentData.findIndex(
        (i) => i.id == data.id
      );
      const live =
        dataInd !== -1 ? this.componentData[dataInd] : data;
      if (evt && evt.shiftKey && live && live.id !== "Back") {
        eventBus.$emit("toggleShiftSelect", live);
        return;
      }
      this.setActive(live, dataInd !== -1 ? dataInd : undefined);
    },
    syncTreeHighlight(scrollToCenter) {
      this.$nextTick(() => {
        const tree = this.$refs.compTree;
        if (!tree) {
          return;
        }
        this.clearMultiHighlight();
        if (this.isMultiSelect) {
          tree.setCurrentKey(null);
          this.applyMultiHighlight();
          if (scrollToCenter) {
            this.scrollNodeIntoCenter(this.multiSelectedIds[0]);
          }
          return;
        }
        const id = this.treeCurrentKey;
        if (!id) {
          tree.setCurrentKey(null);
          return;
        }
        if (id === "Back") {
          tree.setCurrentKey(null);
          return;
        }
        tree.setCurrentKey(id);
        if (scrollToCenter) {
          this.scrollCurrentIntoCenter();
        }
      });
    },
    scrollNodeIntoCenter(nodeId) {
      if (!nodeId) {
        return;
      }
      this.$nextTick(() => {
        const wrap = this.$refs.scrollWrap;
        const tree = this.$refs.compTree;
        if (!wrap || !tree || !tree.getNode) {
          return;
        }
        const node = tree.getNode(nodeId);
        const row =
          (node && node.$el && node.$el.querySelector(".el-tree-node__content")) ||
          (node && node.$el);
        if (!row) {
          return;
        }
        const wrapRect = wrap.getBoundingClientRect();
        const elRect = row.getBoundingClientRect();
        const delta =
          elRect.top - wrapRect.top - wrapRect.height / 2 + elRect.height / 2;
        wrap.scrollTop += delta;
      });
    },
    scrollCurrentIntoCenter() {
      this.$nextTick(() => {
        const wrap = this.$refs.scrollWrap;
        if (!wrap) {
          return;
        }
        const el = wrap.querySelector(
          ".el-tree-node.is-current > .el-tree-node__content"
        );
        if (!el) {
          return;
        }
        const wrapRect = wrap.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const delta =
          elRect.top - wrapRect.top - wrapRect.height / 2 + elRect.height / 2;
        wrap.scrollTop += delta;
      });
    },
    setActive(c, ind) {
      eventBus.$emit("hideArea");
      //设置选中的组件
      this.$store.commit("setCurComponent", { component: c, index: ind });
      this.activeCId = c?.id;
      this.syncTreeHighlight(true);
    },
    unlock(data) {
      if (this.curComponent.id !== data.id) {
        const dataInd = this.componentData.findIndex(
          (i) => i.id == data.id
        );
        if (dataInd !== -1) {
          this.setActive(this.componentData[dataInd], dataInd);
        } else {
          this.$message.error('请先点击选择要解锁的组件');
          return;
        }
      }
      if (!this.curComponent || this.curComponent.id === 'Back') {
        this.$message.error('请先点击选择要解锁的组件');
        return;
      }
      if (this.curComponent.compType === ECOLOGICAL_CHILDREN_SIGN) {
        // 如果父组件锁定了，则子组件不能解锁
        const parentCompInd = this.componentData.findIndex((i) => i.id === this.curComponent.parentid); 
        if (this.componentData[parentCompInd].isLock) {
          this.$message.error('请先解锁父组件，才能解锁当前组件');
          return;
        }
      }
      this.$store.commit("unlock");
      if (this.curComponent.compType === ECOLOGICAL_SIGN) {
        // 生态组件要将子组件下的一并处理了
        this.curComponent.propValue.map((item, index) => {
          this.$store.commit("setEcologicalChildData", {
            index: index,
            key: 'isLock',
            value: false
          });
        });
      }
    },
    lock(data) {
      if (this.curComponent.id !== data.id) {
        const dataInd = this.componentData.findIndex(
          (i) => i.id == data.id
        );
        if (dataInd !== -1) {
          this.setActive(this.componentData[dataInd], dataInd);
        } else {
          this.$message.error('请先点击选择要锁定组件');
          return;
        }
      }
      if (!this.curComponent || this.curComponent.id === 'Back') {
        this.$message.error('请先点击选择要锁定组件');
        return;
      }
      this.$store.commit("lock");
      if (this.curComponent.compType === ECOLOGICAL_SIGN) {
        // 生态组件要将子组件下的一并处理了
        this.curComponent.propValue.map((item, index) => {
          this.$store.commit("setEcologicalChildData", {
            index: index,
            key: 'isLock',
            value: true
          });
        });
      }
    },
    deleteC(c) {
      this.setActive(c);
      setTimeout(() => {
        this.$store.commit("deleteComponent");
        this.$store.commit("recordSnapshot");
      }, 50);
    },
  },
};
</script>

<style lang="scss">
.components {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .components-scroll {
    flex: 1;
    min-height: 0;
    overflow: auto;
  }
  .components-back-row {
    flex-shrink: 0;
    height: 40px;
    line-height: 40px;
    border-top: 1px solid #e4e7ed;
    background: #f5f7fa;
    cursor: pointer;
    &.is-current {
      background: #1c92ff;
      color: #fff;
      font-weight: 600;
    }
    .comp-tree-node {
      height: 40px;
      padding-left: 24px;
    }
  }
  .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content {
    background: #1c92ff !important;
    color: #fff;
  }
  .el-tree-node__content.is-multi-current {
    background: #1c92ff !important;
    color: #fff;
  }
  .el-tree-node.is-current > .el-tree-node__content .comp-tree-node,
  .el-tree-node__content.is-multi-current .comp-tree-node {
    color: #fff;
    .layer-bind-dot {
      background: #fff;
    }
  }
  .comp-tree-node.comp-tree-multi-selected {
    font-weight: 600;
  }
  .el-tree-node__content {
    height: 40px;
  }
  .comp-tree-node {
    flex: 1 0 auto;
    display: flex;
    align-items: center;
    width: calc(100% - 24px);
    .comp-left-label {
      flex: 1 0 auto;
      max-width: calc(100% - 56px);
      overflow: hidden;
      display: flex;
      align-items: center;
      i {
        line-height: 22px;
      }
      > span:first-of-type {
        max-width: calc(100% - 64px);
        display: inline-block;
        overflow: hidden;
        text-overflow: ellipsis;
        font-size: 12px;
      }
      .layer-bind-dot {
        display: inline-block;
        width: 6px;
        height: 6px;
        margin: 0 4px;
        border-radius: 50%;
        background: #409eff;
        flex-shrink: 0;
      }
      .el-tag {
        margin-left: 3px;
      }
    }
    .tree-right-btn {
      width: 52px;
      flex-shrink: 0;
      margin-right: 6px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      opacity: 0.35;
      transition: opacity 0.15s ease;
      .el-button {
        font-size: 14px;
        margin: 0 1px;
        padding: 4px;
        color: #909399;
        float: none;
        &:hover {
          color: #409eff;
          background: rgba(64, 158, 255, 0.1);
          border-radius: 4px;
        }
        .el-icon-delete {
          color: inherit;
        }
      }
    }
    &:hover .tree-right-btn {
      opacity: 1;
    }
  }
}
</style>
<style lang="scss" scoped>
.components {
  .component {
    height: 60px;
    background-color: rgb(243, 243, 243);
    display: flex;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    width: 230px;
    display: flex;
    margin-bottom: 16px;
    .type {
      flex: 1;
      background-color: rgb(210, 210, 210);
      position: relative;
      .iconfont {
        position: absolute;
        left: 28%;
        top: 20%;
        font-size: 30px;
        color: #fff;
      }
      .img {
        width: 100%;
        height: 100%;
      }
      .text {
        position: absolute;
        z-index: 1;
        right: 8px;
        bottom: 8px;
        font-size: 12px;
        line-height: 1em;
        color: rgb(255, 255, 255);
        background-color: rgba(0, 0, 0, 0.6);
        padding: 4px 6px;
        border-radius: 4px;
      }
    }
    .operations {
      flex: 1;
      display: flex;
      align-items: flex-end;
      font-size: 22px;
      padding: 10px 0;
      & span {
        margin-left: 10px;
        color: rgb(144, 147, 153);
      }
      & i {
        margin-left: 10px;
      }
      .el-icon-delete {
        color: #f56c6c;
      }
    }
  }
  .activeC {
    border: 1px solid #1c92ff;
  }
}
.comp-tree-error {
  animation: comp-tree-error-pulse 1s ease 4;
  color: #c45656;
  font-weight: 600;
}
@keyframes comp-tree-error-pulse {
  0%,
  100% {
    box-shadow: inset 0 0 0 0 rgba(245, 108, 108, 0.2);
  }
  50% {
    box-shadow: inset 0 0 0 2px #f56c6c;
  }
}
</style>